import SkeletonTable from "@/components/SkeletonTable";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { useTahun } from "@/hooks/useTahun";

const getListRekapBerkasUkt = async (tahun: string) => {
  const response = await api.get("/setting/verifikator-ukt/index", {
    withCredentials: true,
    params: { tahun },
  });
  return response.data;
};

export default function SettingVerifikatorPage() {
  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: ["listRekapBerkasUkt", selectedTahun?.label],
    queryFn: () => getListRekapBerkasUkt(selectedTahun?.label),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  );
}
